// extracted by mini-css-extract-plugin
module.exports = {"container":"_3q6t701Dq0twiHLypXmVXC","title":"fyKJ_GBk_N5w1eOY9Bzx8","description":"U6AAO5mPumXU4yRsjD4Qe"};